
import { useSelector } from "react-redux";
import { useLocation, Navigate } from "react-router-dom";

const PermissionRoute = ({ children }) => {
  const location = useLocation();
  const user = useSelector((state) => state.profile.user);

  const permissions = user?.roles?.[0]?.permissions || [];
  const allowedPaths = permissions.map(p => p.path);

  const currentPath = location.pathname;

  if (allowedPaths.includes(currentPath)) {
    return children;
  }

  return <Navigate to="/unauthorized" />;
};

export default PermissionRoute;
